import { useSelector } from "react-redux";
import { addTheParks, theParksSelector } from "../Redux/appStateSlice";
import { WithFetchJsonContent } from "./WithFetchJsonContent";

export const WithParks = ({ children }) => {
  const parksData = useSelector(theParksSelector);

  return (
    <WithFetchJsonContent reduxInStore={parksData} addToReduxFunction={addTheParks} jsonLocation="PARKLIST">
      {children}
    </WithFetchJsonContent>
  );
};
